import { find, get, isEmpty, isNumber, lowerCase, set } from 'lodash';

const _ = {
  get,
  find,
  lowerCase,
  isNumber,
  set,
  isEmpty,
};

export default _;
